import _values from 'lodash/values';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {Nodes} from 'common/src/modules/nodes/nodes.types';

export default function getTreeArrayRepresentation(nodes: Nodes) {
  const arrayRepresentation: Array<Array<number>> = [];

  _values(nodes).forEach((mapNode) => {
    if (!arrayRepresentation[mapNode.id]) {
      arrayRepresentation[mapNode.id] = [];
    }

    mapNode.outputs.forEach((output) => {
      output.nodeId !== NO_NODE_ID && arrayRepresentation[mapNode.id].push(output.nodeId);
    });
  });

  return arrayRepresentation;
}
